module.exports = __webpack_public_path__ + "static/media/Emboar_gaussian2.bd15b8ab.png";